import { getData } from '@atresmedia/elections_modules_library';

export const getRoute = (town, community, excludes, reload) => {
  if (parseInt(reload) === 2) {
    return getStaticRoute(town);
  }
  return getNewsRoute(town, community, excludes);
};

export const getNewsRoute = (town, community, excludes) => {
  let locale = '';
  if (town.path) {
    const path = town.path.split('/');
    locale = community ? path.pop() : path[1];
  } else {
    locale = town.name;
  }
  let ineId = community ? town.ineId : town.parentId;
  if (!ineId) ineId = community;

  const host = window.location.hostname.replace('localhost', 'antena3.com');
  if (excludes && Boolean(excludes[ineId])) {
    return excludes[ineId];
  }

  const { community: communityId } = getParams(town);

  if (host.indexOf('lasexta') !== -1) {
    if (communityId === 'R12')
      return `https://www.lasexta.com/noticias/nacional/elecciones-galicia/resultados-elecciones-2020-en-${locale}-${ineId}`;
    if (communityId === 'R16')
      return `https://www.lasexta.com/noticias/nacional/elecciones-pais-vasco/resultados-elecciones-2020-en-${locale}-${ineId}`;
  }
  if (host.indexOf('antena3') !== -1) {
    if (communityId === 'R12')
      return `https://www.antena3.com/noticias/espana/resultado-elecciones-gallegas-2020-${locale}-${ineId}`;
    if (communityId === 'R16')
      return `https://www.antena3.com/noticias/elecciones/elecciones-vascas/resultado-elecciones-vascas-2020-${locale}-${ineId}`;
  }
  if (host.indexOf('ondacero') !== -1) {
    if (communityId === 'R12')
      return `https://www.ondacero.es/noticias/elecciones-galicia/resultado-elecciones-gallegas-2020-${locale}-${ineId}`;
    if (communityId === 'R16')
      return `https://www.ondacero.es/noticias/elecciones-pais-vasco/resultado-elecciones-vascas-2020-${locale}-${ineId}`;
  }
};

export const getStaticRoute = (town) => {
  const host = window.location.hostname.replace('localhost', 'ondacero.com');
  const { community: communityId } = getParams(town);

  let path = '';
  if (town.path) {
    path = town.path;

    return setStaticUrl(host, communityId, path);
  } else {
    getData(communityId).then((place) =>
      setStaticUrl(host, communityId, place.path)
    );
  }
};

const setStaticUrl = (host, communityId, path) => {
  if (host.indexOf('lasexta') !== -1) {
    if (communityId === 'R12')
      return `https://www.lasexta.com/noticias/elecciones-galicia/resultados${path}`;
    if (communityId === 'R16')
      return `https://www.lasexta.com/noticias/elecciones-vascas/resultados${path}`;
  }
  if (host.indexOf('ondacero') !== -1) {
    return `https://www.ondacero.es/noticias/elecciones-municipales-autonomicas/resultados-autonomicas${path}`;
  }
  if (host.indexOf('antena3') !== -1) {
    return '';
  }
};

export const navigateTo = (
  history,
  reload,
  internalPath,
  item,
  community,
  excludes
) => {
  if (parseInt(reload) === 0) {
    history.push(internalPath);
  } else if (parseInt(reload) === 1) {
    const path = getNewsRoute(item, community, excludes);
    window.parent.location.href = path;
  } else if (parseInt(reload) === 2) {
    const pathPromise = () => {
      if (item.path) {
        return item;
      }
      const { community: communityId } = getParams(item);
      return getData(communityId);
    };
    Promise.resolve(pathPromise()).then((item) => {
      const path = getStaticRoute(item);
      if (path) {
        window.parent.location.href = path;
      } else {
        history.push(internalPath);
      }
    });
  }
};

export const getParams = (location) => {
  if (location) {
    switch (location.typePlace) {
      case 'REGION':
        return { community: location.ineId };
      case 'PROVINCE':
        return { community: location.parentId, province: location.ineId };
      case 'TOWN':
        return {
          community: location.grandpaId,
          province: location.parentId,
          town: location.ineId,
        };
      default:
        return { community: location.parentId };
    }
  } else {
    return {};
  }
};
